import { useCallback, useState } from "react";
import { useApi } from "@micromag/data";

const useMediaJobRestart = () => {
    const [restarting, setRestarting] = useState(false);
    const api = useApi();
    const restart = useCallback(
        (mediaId, jobId) => {
            setRestarting(true);
            return api.medias.restartMediaJob(mediaId, jobId).then(response => {
                setRestarting(false);
                return response;
            })
        }
    );
    return { restart, restarting };
};

export default useMediaJobRestart;
